import { useEffect } from 'react'
import { startListening } from '@core/Store/listenerMiddleware'
import { confirmAllBets } from '@mobi/betslip/Store/Workflow/asyncActions'
import { setQualtricsIntercept } from '@core/Areas/Qualtrics/qualtrics'
import { FobBetReceiptResponse } from '@mobi/betslip/types'

export const useSetQualtricsOnBetPlaced = (shouldEnable: boolean) => {
  useEffect(() => {
    if (!shouldEnable) return undefined

    const stopListener = startListening({
      actionCreator: confirmAllBets.fulfilled,
      effect: action => {
        if (
          action.payload.some(
            responseItem =>
              responseItem.receipt &&
              'specialOffers' in responseItem.receipt &&
              ((responseItem.receipt as FobBetReceiptResponse)?.specialOffers?.length ?? 0) > 0
          )
        ) {
          setQualtricsIntercept('special')
        } else if (action.payload.some(responseItem => responseItem.receipt?.bonusBet)) {
          setQualtricsIntercept('bonus')
        } else if (action.payload.some(responseItem => !!responseItem.receipt)) {
          setQualtricsIntercept('bet')
        }
      },
    })

    return () => stopListener()
  }, [shouldEnable])
}
